/**
 * URL 查询参数（与详情页 `urlParams` 行为对齐，供结果页页面配置与广告等使用）
 */
const getUrlParam = (() => {
    const paramCache: Record<string, string> = {};

    return (name: string, link?: string) => {
        if (paramCache[name] !== undefined) {
            return paramCache[name];
        }

        const urlParams = new URLSearchParams(link || window.location.search);
        const param = urlParams.get(name);
        const decodedParam = param ? decodeURIComponent(param) : '';

        paramCache[name] = decodedParam;
        return decodedParam;
    };
})();

const setUrlParam = (name: string, value: string, link?: string) => {
    const url = link || window.location.href;
    const urlObj = new URL(url);
    urlObj.searchParams.set(name, value);
    return urlObj.toString();
};

export const getLangFromUrl = () => {
    return getUrlParam('l').toLowerCase() || 'en';
};

export const getRegionFromUrl = () => {
    return getUrlParam('r').toUpperCase() || 'ID';
};

export const getContentIdFromUrl = () => {
    return getUrlParam('cid');
};

export const getImageIdFromUrl = () => {
    return getUrlParam('iid');
};

export const getChannelIdFromUrl = () => {
    return getUrlParam('ch');
};

export const getQueryFromUrl = () => {
    return getUrlParam('q');
};

export const getMappedRegionFromUrl = () => {
    return getUrlParam('fbR');
};

export const getVersionFromUrl = () => {
    return getUrlParam('v');
};

export const getPageIdFromUrl = () => {
    return getUrlParam('pid');
};

export const getSourceIdFromUrl = () => {
    return getUrlParam('sid');
};

export const getGrayFromUrl = () => {
    return getUrlParam('gray');
};

export const getBrandFromUrl = () => {
    return getUrlParam('br');
};

export const getArticleModeFromUrl = () => {
    return getUrlParam('articleMode');
};

export const getRecommendModeFromUrl = () => {
    return getUrlParam('recommendMode');
};

export const setImageIdToUrl = (imageId: string, link?: string) => {
    return setUrlParam('iid', imageId, link);
};

export const setArticleModeToUrl = (articleMode: string, link?: string) => {
    return setUrlParam('articleMode', articleMode, link);
};

export const setRecommendModeToUrl = (recommendMode: string, link?: string) => {
    return setUrlParam('recommendMode', recommendMode, link);
};

export const getJumpTypeFromUrl = () => {
    return getUrlParam('jumpType');
};

export const setJumpTypeToUrl = (jumpType: string, link?: string) => {
    return setUrlParam('jumpType', jumpType, link);
};

/**
 * 获取内容类型
 * @returns '1'-专题内容, '0'-常规内容
 */
export const getContentTypeFromUrl = () => {
    return getUrlParam('cType');
};
